// What does the currently selected agreement type become on a category
// change? (Owner ruling 2026-07-14: changing category must never wipe a
// still-valid type — on tenants where e.g. "Confidentiality Agreement"
// exists in every category, Corporate→Customer used to clear the CDA.)
//
// Returns the PRESERVED value ('' when the type does not survive). The
// return is canonical-cased and mirrors exactly what the type <select> can
// RENDER in the new category — preserving a value the select can't show
// would leave a phantom-blank control holding a submittable stale value:
//  * plain types survive iff a same-name row exists in the new category;
//    amendment-style rows (hidden from the normal options) survive only on
//    an EXACT name match (the select's keep-visible option requires it);
//  * "Amendment to <base>" survives iff the new category composes that
//    option: base row present, NOT amendment-style, name not ^Amendment,
//    not Online Terms — the same filters the Amendments optgroup applies.
//
// Plain CommonJS on purpose: imported by IntakeModal (webpack interops) and
// required directly by the backend jest suite for the preservation matrix.
function preservedTypeAcrossCategoryChange(type, newCategory, contractTypes) {
  if (!type || !newCategory) return '';
  const rows = (contractTypes || []).filter((t) => t && t.category === newCategory);
  const norm = (s) => String(s || '').trim().toLowerCase();

  const amend = /^amendment to (.+)$/i.exec(type);
  if (amend) {
    const base = rows.find((t) =>
      norm(t.name) === norm(amend[1])
      && !t.is_amendment_style
      && !/^amendment/i.test(t.name || '')
      && !/^online\s*terms$/i.test(t.name || ''));
    return base ? `Amendment to ${base.name}` : '';
  }

  const row = rows.find((t) => norm(t.name) === norm(type));
  if (!row) return '';
  // Amendment-style rows are hidden from the normal option list; the select
  // only keeps them visible as the current selection on an EXACT name match.
  if (row.is_amendment_style) return row.name === type ? row.name : '';
  return row.name; // canonical casing — always renderable
}

module.exports = { preservedTypeAcrossCategoryChange };
